module.exports = __webpack_public_path__ + "img/Inflammation-PRCA_SpatialResearch.75c5b14b.png";